import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';

import { useToggle } from 'src/hooks/useToggle';
import { AppDialog } from 'src/components/app-dialog';
import { AppButton, AppTypography, StackColumn, StackRow } from 'src/components';

//
//

const ProgrammeRenameDialog: React.FC<{
  currentName: string;
  onRename: (newName: string) => void;
  toggle: ReturnType<typeof useToggle>;
  isLoading: boolean;
}> = ({ currentName, onRename, toggle, isLoading }) => {
  const [newName, setNewName] = useState(currentName);

  useEffect(() => setNewName(currentName), [currentName]);

  //

  return (
    <AppDialog
      open={toggle.value}
      onClose={toggle.off}
      title="Rename the programme"
      actions={
        <StackRow gap={1}>
          <AppButton variant="outlined" onClick={toggle.off}>
            Cancel
          </AppButton>
          <AppButton
            loading={isLoading}
            variant="contained"
            onClick={() => onRename(newName)}
            disabled={!newName}
          >
            Rename
          </AppButton>
        </StackRow>
      }
    >
      <StackColumn>
        <AppTypography>
          You can assign a custom name to your programme to make your navigation easier.
        </AppTypography>

        <TextField
          name="programmename"
          fullWidth
          type="text"
          size="small"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
        />
      </StackColumn>
    </AppDialog>
  );
};

export default ProgrammeRenameDialog;
